import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';
import GeneralAction from '../panel/generalAction';
import { useNavigate } from 'react-router-dom';

import api from '../../API/api';



export default function ViewSchools(props) {

    const navigation = useNavigate()



    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead sx={{ backgroundColor: 'black' }}>
                    <TableRow>
                        <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>School Name</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="">Principal</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Cource</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Faculty</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.schools && props.schools.map((row) => (
                        <TableRow
                            key={row.name}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell align="">{row.schoolName}</TableCell>
                            <TableCell align="">{row.principalName}</TableCell>
                            <TableCell align="right"> <Button size='small' onClick={() => navigation(`/admin/addCourse/${row.id}`)} >+Course </Button> </TableCell>
                            <TableCell align="right"> <Button size='small' onClick={() => navigation(`/admin/AddFacalty/${row.id}`)} >+Faculty </Button> </TableCell>
                            <TableCell align="right"> 
                                 <GeneralAction type="school" data={row} handleClickOpen={props.handleClickOpen} handleClose={props.handleClose} /> </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}